module.exports = __webpack_public_path__ + "img/generate-bg.1b3d2926.png";